import { render, staticRenderFns } from "./FormularioCoinPago.vue?vue&type=template&id=0af42ba2&scoped=true"
import script from "./FormularioCoinPago.vue?vue&type=script&lang=js"
export * from "./FormularioCoinPago.vue?vue&type=script&lang=js"
import style0 from "./FormularioCoinPago.vue?vue&type=style&index=0&id=0af42ba2&prod&scoped=true&lang=css"
import style1 from "./FormularioCoinPago.vue?vue&type=style&index=1&id=0af42ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af42ba2",
  null
  
)

export default component.exports